import React, { FC, memo, Fragment } from 'react'
import { useSelector } from 'react-redux'

import { p11n, getApiImageUrl } from '@ucheba/utils/helpers/string'

import { articlesSelectors } from '@ucheba/store/articles'

import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { ListItem } from '@ucheba/ui/components/List/desktop'
import { Banner } from '../../../../../../components/Banner/desktop'
import Pagination from '../../../../components/Pagination/desktop'

import { ListStyled, Cover, Space } from '../styles'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'

const ArticleList: FC = () => {
  const { items, total } = useSelector(articlesSelectors.entity)
  const articleItems = [...items]

  const firstTwoElements = articleItems.splice(0, 2)

  const { extraParams, paidPackage } = useBannerProgramTypes()

  return (
    <>
      {!!firstTwoElements.length && (
        <ListStyled isOneItem={firstTwoElements.length === 1}>
          {firstTwoElements?.map(({ id, imageFile, title, announce }) => (
            <Fragment key={id}>
              <ListItem width='auto'>
                {imageFile && (
                  <a href={`/article/${id}`}>
                    <Cover src={getApiImageUrl(`/pix/article/${imageFile}`)} />
                  </a>
                )}

                <Spacing spacing='small' />

                {title && (
                  <a href={`/article/${id}`}>
                    <Text
                      spacing='xxsmall'
                      color='blue'
                      fontSize='h3'
                      lineHeight='h3'
                      fontWeight='bold'
                    >
                      {title}
                    </Text>
                  </a>
                )}

                <Text fontSize='h5' lineHeight='h4'>
                  {announce}
                </Text>
              </ListItem>
            </Fragment>
          ))}
        </ListStyled>
      )}

      {!isPaidPackage(paidPackage) ? (
        <>
          <Banner id={2} spacing={{ top: 'xxlarge' }} extraParams={extraParams} />

          <Space />
        </>
      ) : (
        <Spacing spacing='xlarge' />
      )}

      {!!articleItems.length && (
        <ListStyled isOneItem={articleItems.length === 1}>
          {articleItems?.map(({ id, imageFile, title, announce }) => (
            <Fragment key={id}>
              <ListItem>
                {imageFile && (
                  <a href={`/article/${id}`}>
                    <Cover src={getApiImageUrl(`/pix/article/${imageFile}`)} />
                  </a>
                )}

                <Spacing spacing='small' />

                {title && (
                  <a href={`/article/${id}`}>
                    <Text
                      spacing='xxsmall'
                      color='blue'
                      fontSize='h3'
                      lineHeight='h3'
                      fontWeight='bold'
                    >
                      {title}
                    </Text>
                  </a>
                )}

                <Text fontSize='h5' lineHeight='h4'>
                  {announce}
                </Text>
              </ListItem>
            </Fragment>
          ))}
        </ListStyled>
      )}

      {total > 16 && (
        <>
          <Divider />

          <Pagination
            showItemsCount={16}
            totalCount={`${total} ${p11n(total || 0, 'статья', 'статьи', 'статей')}`}
            total={total}
          />
        </>
      )}

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default memo(ArticleList)
